import { createV3Queries } from "@query/utils/createV3Queries";
import { tagsApi } from "@api";

export const queriesTags = createV3Queries("tagsApi", tagsApi);
